import classes from "./Home.module.css";
import React, { useEffect, useState, useRef } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import Accordion from '../UI/Accordion/Accordion'
import CVs from "../CVs/ReferenceCPs/CVs";
import Commercial from "../CVs/CommercialCPs/Commercial";
import {
    addMemberToSite,
    getLocalDictionary,
    searchAllUsers,
    searchChildrenByDriveId,
    searchDriveByPath,
    searchFileByKey,
    searchMembersByGroupId,
    updateFileContentByFileId
} from "../../graph-services/GraphServices";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import Spelling from "spelling";
import NL from "../../dictionaries/nl-NL/index.json"
import FR from "../../dictionaries/fr-FR/index.json"
import EN from "../../dictionaries/en-EN/index.json"
import Notifier from "../UI/Notifier/Notifier";
import { translation } from "../../I18n/i18n";

const Home = (props) => {
    const defaultLanguage = { code: "en", label: "English" }
    const lang = useSelector(state => state.languageReducer.language)
    const [referenceDriveId, setReferenceDriveId] = useState('');
    const [commercialDriveId, setCommercialDriveId] = useState('');
    const [isRefCPExpanded, setIsRefCPExpanded] = useState(!props.isHrMember && !props.isSalesMember && !props.isAdminMember);
    const [isSalCPExpanded, setIsSalCPExpanded] = useState(false);
    const [isHrMember] = useState(props.isHrMember);
    const [isSalesMember] = useState(props.isSalesMember);
    const [isAdminMember] = useState(props.isAdminMember);

    let [isReferenceCPsLoaded, setIsReferenceCPsLoaded] = useState(false)
    let [isCommercialCPsLoaded, setIsCommercialCPsLoaded] = useState(false)

    const hasRefCPBeenExpanded = useRef(isRefCPExpanded || false);
    const hasSalCPExpanded = useRef(false);
    useEffect(() => {
        handleLoading(false);
    }, []);
    let [clients, setClients] = useState(Array);
    let [opportunities, setOpportunities] = useState(Array);
    let updateClients = () => {
        searchChildrenByDriveId(
            props.access_token,
            props.site.id,
            commercialDriveId
        ).then((r) => {
            let result = [];
            if (_.isArray(r.value)) {
                r.value.map((e) => {
                    result.push({
                        name: e.name,
                        id: e.id,
                    });
                    return result;
                });
            }
            setClients(result);
        });
    };
    let updateOpportunity = () => {
        let groupedOpportunities = [];
        clients.forEach(function (client) {
            searchChildrenByDriveId(
                props.access_token,
                props.site.id,
                client.id
            ).then((r) => {
                let opportunities = [];
                if (_.isArray(r.value)) {
                    r.value.map((e) => {
                        opportunities.push({
                            value: {
                                name: e.name,
                                id: e.id,
                                client: {
                                    name: client.name,
                                    id: client.id,
                                },
                            },
                            label: e.name,
                        });
                        return opportunities;
                    });
                }
                groupedOpportunities.push({
                    label: client.name,
                    options: opportunities,
                });
            });
        });
        setOpportunities(groupedOpportunities);
    };

    useEffect(() => {
        if (_.isEmpty(clients) && props.access_token !== "" && commercialDriveId !== "") {
            updateClients()
        }
    }, [props.access_token, commercialDriveId])

    useEffect(() => {
        if (props.access_token !== "") {
            updateOpportunity()
        }
    }, [clients])

    let getDictionary = (lang) => {
        let localDict = allLocalDictionaries && allLocalDictionaries[lang] ? allLocalDictionaries[lang].data : []
        let dict = {
            fr: localDict.concat(FR),
            en: localDict.concat(EN),
            nl: localDict.concat(NL),
            default: EN
        }

        return lang ? dict[lang] : dict.default
    }

    let [allLocalDictionaries, setAllLocalDictionaries] = useState(null)

    useEffect(() => {
        if (props.access_token !== "" && (isReferenceCPsLoaded || isCommercialCPsLoaded)) {
            getLocalDictionary(props.access_token, props.site.id)
                .then(r => {
                    setAllLocalDictionaries(r)
                })
        }
    }, [props.access_token, isReferenceCPsLoaded, isCommercialCPsLoaded])

    let [dictionary, setDictionary] = useState(Spelling(getDictionary(lang)))

    useEffect(() => {
        setDictionary(Spelling(getDictionary(lang)))
    }, [lang, allLocalDictionaries])

    useEffect(() => {
        checkSession(props.sessionExpired)
    }, [props.sessionExpired])

    let addToDictionary = async (newTerm) => {
        getLocalDictionary(props.access_token, props.site.id)
            .then(r => setAllLocalDictionaries(r))

        let dictEntity = {
            "dictionary": {
                "terms": allLocalDictionaries[lang].data.concat(newTerm)
            }
        }

        return await updateFileContentByFileId(props.access_token, props.site.id, allLocalDictionaries[lang].fileID, dictEntity)
    }

    let [allUsers, setAllUsers] = useState([])

    useEffect(() => {
        if (props.access_token && (isAdminMember || isHrMember) && !allUsers.length) {
            getUsers()
                .then(async r => {
                    setAllUsers(r)
                    if (isHrMember || isAdminMember) {
                        await searchMembersByGroupId(props.access_token, props.membersGroupId).then(res => {
                            r.filter(x => !res.map(x => x.id).includes(x.id))
                                .forEach(x => {
                                    addMemberToSite(props.access_token, props.membersGroupId, x.id);
                                })
                        })
                    }
                })
        }
    }, [props.access_token, isAdminMember, isHrMember])


    useEffect(() => {
        if ((isHrMember || isAdminMember) && referenceDriveId === "" && (isReferenceCPsLoaded || isCommercialCPsLoaded)) {
            let referenceFolderPath = `${process.env.REACT_APP_LIBRARY_FOLDER}/${process.env.REACT_APP_REFERENCE_FOLDER}/${process.env.REACT_APP_CREATED_FOLDER}`
            searchDriveByPath(props.access_token, props.site.id, referenceFolderPath)
                .then(d => d && setReferenceDriveId(d.id))
        }
    }, [isHrMember, isAdminMember, isReferenceCPsLoaded, isCommercialCPsLoaded])

    useEffect(() => {
        if ((isSalesMember || isAdminMember) && commercialDriveId === "" && (isReferenceCPsLoaded || isCommercialCPsLoaded)) {
            let salesFolderPath = `${process.env.REACT_APP_LIBRARY_FOLDER}/${process.env.REACT_APP_SALES_FOLDER}`
            searchDriveByPath(props.access_token, props.site.id, salesFolderPath)
                .then(d => d && setCommercialDriveId(d.id))
        }
    }, [isSalesMember, isAdminMember, isReferenceCPsLoaded, isCommercialCPsLoaded])

    let getUsers = async () => {
        let users = await searchAllUsers(props.access_token)
        let data = []

        for (let El of users) {
            if (El.userPrincipalName && El.id && El.displayName) {
                data.push({
                    mail: El.userPrincipalName,
                    displayName: El.displayName,
                    givenName: El.givenName,
                    surname: El.surname,
                    id: El.id,
                    photo: null,
                })
            }
        }
        return data
    }


    // handle Notification
    let [notification, setNotification] = useState({ open: false, message: null, severity: null })

    let displayNotification = (message, severity) => {
        setNotification({ open: true, message: translation(lang, message), severity: severity })
    }

    let notificationBox = <Notifier lang={lang}
        setState={setNotification}
        {...notification} />

    let handleLoading = (v) => {
        props.onLoading(v);
    }

    let checkSession = (v) => {
        props.checkSession(v);
    }

    const handleAccordionRefChange = (panel) => (event, isExpanded) => {
        setIsRefCPExpanded(isExpanded ? panel : false);
        hasRefCPBeenExpanded.current = true;
    }

    const handleAccordionSalChange = (panel) => (event, isExpanded) => {
        setIsSalCPExpanded(isExpanded ? panel : false);
        hasSalCPExpanded.current = true;
    }
    const dispatch = useDispatch()
    let changeLanguage = (language) => {
        dispatch({ type: language })
    }
    let [reloadCommercial, setReloadCommercial] = useState(new Function())
    let [commercialData, setCommercialData] = useState([])

    const fetchCommercialCvs=()=>{
        searchFileByKey(props.access_token, props.site.id, props.listId, props.site.webUrl,"", "Sales", false)
            .then(files => {
                let data = []
                if (Array.isArray(files)) {
                    files.map(f => data.push(f))
                }
                setCommercialData(data)
            })
    }
    
    useEffect(()=>{
        if(props.access_token !== "" && props.listId!=="" && !isSalCPExpanded) {
            fetchCommercialCvs()
            setReloadCommercial(() => () => fetchCommercialCvs())  
        }     
    } 
    ,[props.access_token,props.listId,isSalCPExpanded])

    let accordionForSales = (isAdminMember || isHrMember || isSalesMember) ? (
        <Accordion title="Commercial Consultant Profiles" isExpanded={isSalCPExpanded}
            clickAccordion={handleAccordionSalChange(true)}>
            {hasSalCPExpanded.current && <Commercial
                dict={dictionary}
                addToDictionary={addToDictionary}
                lang={lang}
                defaultLanguage={defaultLanguage}
                changeLanguage={(language) => changeLanguage(language)}
                siteId={props.site.id}
                listId={props.listId}
                webUrl={props.site.webUrl}
                access_token={props.access_token}
                onLoading={(v) => handleLoading(v)}
                isHrMember={isHrMember}
                isSalesMember={isSalesMember}
                isAdminMember={isAdminMember}
                salesDriveId={commercialDriveId}
                clients={clients}
                updateClients={() => updateClients()}
                salesGroupId={props.salesGroupId}
                opportunities={opportunities}
                updateOpportunities={updateOpportunity}
                userEmail={props.userEmail}
                setIsCommercialCPsLoaded={(v) => setIsCommercialCPsLoaded(v)}
                allUsers={allUsers}
                notify={displayNotification}
                setReloadCommercial={setReloadCommercial}
                setCommercialData={setCommercialData}
                commercialData={commercialData}
            />}
        </Accordion>
    ) : null;

    let content = (props.access_token === "") ? null :
        (
            <div className={classes.Home}>
                <Accordion title="Reference Consultant Profiles" isExpanded={isRefCPExpanded}
                    clickAccordion={handleAccordionRefChange(true)}>
                    {hasRefCPBeenExpanded.current && (<CVs
                        dict={dictionary}
                        addToDictionary={addToDictionary}
                        lang={lang}
                        defaultLanguage={defaultLanguage}
                        changeLanguage={(language) => changeLanguage(language)}
                        siteId={props.site.id}
                        listId={props.listId}
                        driveId={referenceDriveId}
                        siteName={props.site.name}
                        webUrl={props.site.webUrl}
                        access_token={props.access_token}
                        onLoading={(v) => handleLoading(v)}
                        checkSession={(v) => checkSession(v)}
                        isHrMember={isHrMember}
                        opportunities={opportunities}
                        isSalesMember={isSalesMember}
                        isAdminMember={isAdminMember}
                        userEmail={props.userEmail}
                        setIsReferenceCPsLoaded={(v) => setIsReferenceCPsLoaded(v)}
                        allUsers={allUsers}
                        notify={displayNotification}
                        reloadCommercial={reloadCommercial}
                        commercialData={commercialData}
                    />)}
                </Accordion>
                {accordionForSales}
                {notificationBox}
            </div>
        );

    return <div>{content}</div>;
};

export default Home;